import Immutable from 'seamless-immutable';
// --- external imports ------

import * as types from './actionTypes';
// --- local imports ------

const initialState = Immutable({
	availableAds: [],
	boughtAds: [],
	isHireAdSuccessful: false,
});

export default function reduce(state = initialState, action = {}) {
	switch (action.type) {
	case types.ADS_AVAILABLE_ADS_LOADED:
		return state.merge({ availableAds: action.availableAds });
	case types.ADS_BOUGHT_ADS_LOADED: 
		return state.merge({ boughtAds: action.boughtAds });
	case types.ADS_RENT: 
		return state.merge({
			boughtAds: [...state.boughtAds, action.boughtAd],
			isHireAdSuccessful: true,
		});
	case types.ADS_STOP: {
		const stoppedAdId = action.stoppedAdId;
		let adIndexToStop = state.boughtAds.findIndex(
			(ad) => ad.id === stoppedAdId
		);
		let boughtAds = Immutable.set(state.boughtAds, adIndexToStop, {
			...state.boughtAds[adIndexToStop],
			running: false,
			endDate: action.endingTurnDate,
		});
		return state.merge({ boughtAds });
	}
	default:
		return state;
	}
}
